export { default as AnalyticsSiteOfCareTable } from './AnalyticsSiteOfCareTable';
